import { PayloadAction } from '@reduxjs/toolkit'
import { put } from 'redux-saga/effects'
import { setIdToken, setAccessToken, clearTokens } from 'store/features/auth'

export function* setCustomerIdToken({
  payload,
}: PayloadAction<string>): Generator {
  try {
    yield put(setIdToken(payload))
  } catch (e) {
    console.log(e)
  }
}

export function* setCustomerAccessToken({
  payload,
}: PayloadAction<string>): Generator {
  try {
    yield put(setAccessToken(payload))
  } catch (e) {
    console.log(e)
  }
}

export function* clearCustomerTokens(): Generator {
  try {
    yield put(clearTokens())
  } catch (e) {
    console.log(e)
  }
}
